// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCEB9ys-LCjL1HcVoPCcl-vvylr_5GGATc",
  authDomain: "allmytunes-8c935.firebaseapp.com",
  projectId: "allmytunes-8c935",
  storageBucket: "allmytunes-8c935.firebasestorage.app",
  messagingSenderId: "932183802285",
  appId: "1:932183802285:web:2281388436b49dd7fb6124"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);